import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54146da0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-24 -md:pt-16 p-5" }
const _hoisted_2 = { class: "px-6 py-4" }
const _hoisted_3 = { class: "title text-left pb-5" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_5 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_6 = { class: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }
const _hoisted_7 = { class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" }
const _hoisted_8 = { class: "block w-auto md:flex m-3 gap-5" }
const _hoisted_9 = {
  id: "example",
  class: "stripe hover",
  style: {"width":"100%","padding-top":"1em","padding-bottom":"1em"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("caption", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "1"
    }, "Pacote"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "2"
    }, "Titulo"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "2"
    }, "Descrição"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "2"
    }, "Data Inicial"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "3"
    }, "Data Final"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      "data-priority": "3"
    }, " ")
  ])
], -1))
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "flex gap-5 h-full" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "py-8 pt-3 w-full" }
const _hoisted_17 = { class: "block md:flex gap-5" }
const _hoisted_18 = { class: "block mb-5" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " Descrição ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_22 = { class: "gap-5 flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Input = _resolveComponent("Input")!
  const _component_VueEditor = _resolveComponent("VueEditor")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(!_ctx.registering ? 'Mensagens' : !this.updating ? 'Cadastrar nova mensagem' : 'Editar mensagem'), 1),
      (!_ctx.registering)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_Select, {
                      selected: "Produto",
                      label: "",
                      options: () => _ctx.selectValues,
                      display: "descricao",
                      itemId: "value",
                      labelClass: "p-0 text-left",
                      event: "update:editValue",
                      class: "w-fill",
                      "onUpdate:editValue": _ctx.changeTypeFilter
                    }, null, 8, ["options", "onUpdate:editValue"]),
                    _createVNode(_component_PrimaryButton, {
                      isLoading: _ctx.loading,
                      label: "Nova Mensagem",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.registering = true)),
                      class: "mt-1 divide-transparent text-white w-2/5"
                    }, null, 8, ["isLoading"])
                  ]),
                  _createElementVNode("table", _hoisted_9, [
                    _hoisted_10,
                    _hoisted_11,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mensagens.resposta, (message) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: message.pacote
                        }, [
                          _createElementVNode("td", null, _toDisplayString(message.handle_pacote), 1),
                          _createElementVNode("td", null, _toDisplayString(message.titulo), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", {
                              innerHTML: message.descricao
                            }, null, 8, _hoisted_12)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(message.data_inicio)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(message.data_final)), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", {
                                onClick: ($event: any) => (_ctx.update(message))
                              }, [
                                _createVNode(_component_FontAwesomeIcon, {
                                  class: "text-yellow-300 cursor-pointer mx-auto",
                                  icon: _ctx.pen
                                }, null, 8, ["icon"])
                              ], 8, _hoisted_14),
                              _createElementVNode("div", {
                                onClick: ($event: any) => (_ctx.deleteMessage(message))
                              }, [
                                _createVNode(_component_FontAwesomeIcon, {
                                  class: "text-red-500 cursor-pointer mx-auto",
                                  icon: _ctx.trash
                                }, null, 8, ["icon"])
                              ], 8, _hoisted_15)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.registering)
        ? (_openBlock(), _createBlock(_component_Card, {
            key: 1,
            class: "pt-8 px-6",
            width: "max-full",
            orientation: "flex-col"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_Select, {
                    selected: _ctx.mensagem.handle_pacote ? _ctx.selectValues.filter((pacote) => pacote.handle_firebird == _ctx.mensagem.handle_pacote)[0].handle_firebird : null,
                    label: "Produto",
                    options: () => _ctx.selectValues,
                    display: "descricao",
                    itemId: "handle_firebird",
                    labelClass: "p-0 text-left",
                    event: "update:editValue",
                    class: "w-6/6 md:w-3/6",
                    "onUpdate:editValue": _ctx.changeType,
                    incorrectMessage: _ctx.validations.package,
                    isIncorrect: _ctx.validations.package != ''
                  }, null, 8, ["selected", "options", "onUpdate:editValue", "incorrectMessage", "isIncorrect"]),
                  _createVNode(_component_Input, {
                    label: "Título",
                    class: "w-6/6 md:w-3/6",
                    incorrectMessage: _ctx.validations.titulo,
                    isIncorrect: _ctx.validations.titulo != '',
                    labelClass: "p-0 text-left",
                    modelValue: _ctx.mensagem.titulo,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mensagem.titulo) = $event))
                  }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _hoisted_20,
                  _createVNode(_component_VueEditor, {
                    modelValue: _ctx.mensagem.descricao,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mensagem.descricao) = $event)),
                    class: "w-full rounded"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.mensagem.dates,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mensagem.dates) = $event)),
                  "is-range": "",
                  columns: _ctx.width() > 768 ? 2 : 1,
                  class: _normalizeClass(["my-1", _ctx.validations.dates != '' ? 'border-red-500' : ''])
                }, null, 8, ["modelValue", "columns", "class"]),
                (_ctx.validations.dates != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, " Informe as datas de visibilidade da mensagem! "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_Button, {
                    label: "Voltar",
                    onClick: _ctx.back,
                    class: "p-0 ml-auto my-4 w-full divide-transparent",
                    width: "w-min"
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_PrimaryButton, {
                    isLoading: _ctx.loading,
                    label: "Enviar",
                    onClick: _ctx.send,
                    class: "p-0 my-4 divide-transparent text-white",
                    type: "submit"
                  }, null, 8, ["isLoading", "onClick"])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Modal, {
        type: "warning",
        title: "Tem certeza que deseja excluir essa mensagem?",
        primaryButtonLabel: "Excluir",
        primaryButtonIconClass: "hidden",
        isOpen: _ctx.isDeleting,
        event: "update:closeModal",
        "onUpdate:closeModal": _ctx.deleting,
        additionalButtons: () => [{
          closeOnCLick: true,
          label: 'Cancelar',
          disable: false,
          function: () => {
            this.isDeleting = false
          }
        }]
      }, null, 8, ["isOpen", "onUpdate:closeModal", "additionalButtons"]),
      _createVNode(_component_Toast, {
        label: _ctx.message,
        hidden: _ctx.hidden,
        onHide: _ctx.hide
      }, null, 8, ["label", "hidden", "onHide"])
    ])
  ]))
}